import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ViewportScroller } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, ViewEncapsulation, inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ViewConfig, ViewModes } from '@spartacus/storefront';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ProductListService } from 'src/app/services/feature/product-list.service';
import { SteeringGearService } from 'src/app/services/feature/steeringGear/steering-gear.service';

@Component({
  selector: 'app-kb-steering-gear',
  templateUrl: './kb-steering-gear.component.html',
  styleUrls: ['./kb-steering-gear.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class KbSteeringGearComponent implements OnDestroy {
  isMobile: boolean;
  subscription = new Subscription();
  constructor(
    public breakpointObserver: BreakpointObserver,
  ) {
    this.subscription.add(this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
      .subscribe(result => {
        this.isMobile = result.matches;
        if (this.isMobile) {
          this.setViewMode(this.ViewModes.Grid);
        }
        else {
          this.setViewMode(this.ViewModes.List);
        }
      }));
  }
  ApiData: any;


  kbSteeringService = inject(SteeringGearService);
  kbTempService = inject(ProductListService);
  productListService = inject(ProductListService);
  viewportScroller = inject(ViewportScroller);
  scrollConfig = inject(ViewConfig);
  cdr = inject(ChangeDetectorRef);

  productTypes$: Observable<any>;
  year$: Observable<any>;
  make$: Observable<any>;
  model$: Observable<any>;

  isInfiniteScroll: boolean | undefined;
  defaultPageSize: any = 10;

  productModel: any;
  viewMode$ = new BehaviorSubject<ViewModes>(ViewModes.Grid);
  ViewModes = ViewModes;

  bottomSectionPDP: boolean = false;

  //Method to initialize the form
  steeringGearForm = new FormGroup({
    ProductType: new FormControl('Steering_Gears'),
    Year: new FormControl(null, { validators: Validators.required }),
    Make: new FormControl(null, { validators: Validators.required }),
    Model: new FormControl(null, { validators: Validators.required }),

  });
  makedata: Observable<{ key: string; value: any; }[]>;
  modelData: Observable<{ key: string; value: any; }[]>;

  get form() {
    return this.steeringGearForm.controls;
  }

  ngOnInit() {
    this.isInfiniteScroll = this.scrollConfig.view?.infiniteScroll?.active;

    this.year$ = this.kbSteeringService.getYearDetails(this.steeringGearForm.value.ProductType).pipe(
      map(yearData => {
        return Object.keys(yearData).map(key => ({ key: key, value: yearData[key] }))
          .sort((a, b) => b.key.localeCompare(a.key));
      })
    );

    this.subscription.add(this.steeringGearForm.get('Year').valueChanges.subscribe(year => {
      this.make$ = this.kbSteeringService.getMakeDetails(this.steeringGearForm.value.ProductType, year).pipe(
        map(makeData => {
          return Object.keys(makeData).map(key => ({ key: key, value: makeData[key] }));
        })
      );

    }));
    this.subscription.add(this.steeringGearForm.get('Make').valueChanges.subscribe(make => {
      this.model$ = this.kbSteeringService.getModelDetails(this.steeringGearForm.value.ProductType, this.steeringGearForm.value.Year, make).pipe(
        map(modelData => {
          return Object.keys(modelData).map(key => ({ key: key, value: modelData[key] }));
        })
      );

    }));


    // this.make$=this.kbSteeringService.getMakeDetails();
    // this.model$=this.kbSteeringService.getMakeDetails();
  }

  steeringGearFormreset() {
    this.bottomSectionPDP = false;
    const preserveValue = this.steeringGearForm.get('ProductType').value;
    this.steeringGearForm.reset({
      Year: null,
      Make: null,
      Model: null,
      ProductType: preserveValue,
      // other form controls
    });
  }

  search(currentPage: any, pageSize: any, sort: string, model: any) {
    const pagination = {
      currentPage: currentPage,
      pageSize: pageSize,
      sort: sort,
    };

    this.subscription.add(this.productListService
      .getCustomDocDetails(
        this.defaultPageSize,
        this.productListService.DecodeQuery('000'),
        0,
      )
      .subscribe((data) => {
        this.productListService.seperateDocDetails$.next(data);
        this.productListService.selectedTabIndex.next(7);
        this.cdr.detectChanges();
      }));
  }
  changePageSize(pageSize: any, model: any) {
    this.defaultPageSize = pageSize;
    this.search(model.pagination.currentPage, Number(pageSize), model.pagination.sort, model);
  }
  changePage(page: number, model: any) {
    this.search(page, model.pagination.pageSize, model.pagination.sort, model);
  }
  sortList(e, model) {
    this.subscription.add(this.productListService
      .getCustomDocDetails(
        this.defaultPageSize,
        this.productListService.DecodeQuery(model.currentQuery.query.value),
        model.pagination.currentPage,
        e
      )
      .subscribe((data) => {
        this.productListService.seperateDocDetails$.next(data);

        console.log(data);
      }));
  }
  changePageCustom(currentPage, model, type) {
    this.viewportScroller.scrollToPosition([0, 200]);
    const query = this.productListService.DecodeQuery(model.currentQuery?.query.value);
    if (type == 2) {
      this.subscription.add(this.productListService
        .getDocumentDetails(this.defaultPageSize, query, currentPage, model.pagination.sort)
        .subscribe((data) => {

        }));
    } else if (type === 3) {
      this.subscription.add(this.productListService
        .getSoftwareDetails(this.defaultPageSize, query, currentPage, model.pagination.sort)
        .subscribe((data) => {

        }));
    }
  }

  setViewMode(mode: ViewModes): void {
    this.viewMode$.next(mode);
  }

  onSubmit(): void {
    if (this.steeringGearForm.valid) {


      const payLoadFormat =
      {
        productType: this.form.ProductType.value,
        year: this.form.Year.value,
        make: this.form.Make.value,
        modelz: this.form.Model.value
      };

      this.kbSteeringService.SteeringPayLoad$.next(payLoadFormat);

      this.subscription.add(this.kbSteeringService.submitSteeringData(payLoadFormat, 10, '', 0, '').subscribe(data => {
        this.productListService.SteeringProdDetails$.next(data?.['searchPageData']);
        this.productListService.selectedTabIndex.next(9);
        this.bottomSectionPDP = true;
        this.cdr.detectChanges();
      }));

    }
  }

  ngOnDestroy() {
    this.productListService.selectedTabIndex.next(0);
    this.subscription.unsubscribe();
  }
}
